import React from "react";
import Button from '@mui/material/Button';
import { ValidateLeaseAdminFuncInput } from "./ValidateLeaseAdminFuncInput";
const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  lease,
  navigate,
  _leaseExist,
  _createErrorMessage,
  _deleteLease,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/LeaseOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationLeaseResult = ValidateLeaseAdminFuncInput(
      lease,
      _createErrorMessage
    );

    if (!validationLeaseResult) {
      return;
    }

    _leaseExist({ data: { Id: lease } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("80");
        return;
      }
      _deleteLease({ data: { Id: lease } });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
